<template>
        <div class="content">
            <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                <add-calendar-event>
                </add-calendar-event> 
                </div>
            </div>  
            </div>
        </div>
        </template>
        <script>
        /* eslint-disable */
        import addCalendarEvent from './todo-add-calendar-event'
        export default {
            components: {
                addCalendarEvent
            }
        }
        </script>
        <style lang='scss'>
            .bg-breadcrum{
                background:#fff !important;
            }
            .link-default{
                color: #666!important;
            }
            .fc-past{
                background-color: #fff;
                color: #555;
            }
            .floater-point-event{
                float:right;
                margin-top:-120px;
                margin-right:10px;
            }
        </style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-calendar/base-add-calendar-event.vue